/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { TIMED_ENTRY_PREFIX } from '../constants';

export const FETCH_TOUR_AVAILABILITY = `${TIMED_ENTRY_PREFIX}FETCH_TOUR_AVAILABILITY`;
export const FETCH_TOUR_AVAILABILITY_SUCCESS = `${TIMED_ENTRY_PREFIX}FETCH_TOUR_AVAILABILITY_SUCCESS`;
export const FETCH_TOUR_AVAILABILITY_ERROR = `${TIMED_ENTRY_PREFIX}FETCH_TOUR_AVAILABILITY_ERROR`;
export const SET_FETCH_TOUR_AVAILABILITY_STATUS = `${TIMED_ENTRY_PREFIX}SET_FETCH_TOUR_AVAILABILITY_STATUS`;
export const RESET_TOUR_AVAILABILITY = `${TIMED_ENTRY_PREFIX}RESET_TOUR_AVAILABILITY`;

export const FETCH_FARTHEST_AVAILABILITY = `${TIMED_ENTRY_PREFIX}FETCH_FARTHEST_AVAILABILITY`;
export const FETCH_FARTHEST_AVAILABILITY_SUCCESS = `${TIMED_ENTRY_PREFIX}FETCH_FARTHEST_AVAILABILITY_SUCCESS`;
export const FETCH_FARTHEST_AVAILABILITY_ERROR = `${TIMED_ENTRY_PREFIX}FETCH_FARTHEST_AVAILABILITY_ERROR`;

// Max calendar view is 3-up. Loading 1 additional months give us 1 more than the initial view,
// so when the user clicks next month, the calendar transitions smoothly
export const ADDITIONAL_MONTHS_TO_FETCH = 1;

export function fetchTourAvailabilitySuccess(data) {
    return {
        type: FETCH_TOUR_AVAILABILITY_SUCCESS,
        payload: data,
    };
}

export function fetchTourAvailabilityError(error) {
    return {
        type: FETCH_TOUR_AVAILABILITY_ERROR,
        payload: error,
    };
}

export function setFetchTourAvailabilityStatus(status) {
    return {
        type: SET_FETCH_TOUR_AVAILABILITY_STATUS,
        payload: status,
    };
}

export function fetchTourAvailability({
    facilityId,
    tourId,
    date,
    forceRefresh = false,
}) {
    return (dispatch) => {
        dispatch({
            type: FETCH_TOUR_AVAILABILITY,
            payload: { facilityId, tourId, date, forceRefresh },
        });
        dispatch({
            type: FETCH_FARTHEST_AVAILABILITY,
            payload: { facilityId },
        });
    };
}

export function fetchFarthestAvailabilitySuccess(data) {
    return {
        type: FETCH_FARTHEST_AVAILABILITY_SUCCESS,
        payload: data,
    };
}

export function resetTourAvailability() {
    return {
        type: RESET_TOUR_AVAILABILITY,
    };
}
